import React from "react";
import styled from "styled-components";
import {Header, Title} from "./Headings";
import {longColour, shortColour} from "../../../style/styleConsts";

const Container = styled.div`
    flex-grow: 1;
`;

const Values = styled.div`
    display: flex;
    font-size: 24px;
    height: 36px;
`;

const Value = styled.div`
    opacity: ${props => props.count ? 1 : 0.15};
`;

const LongValue = styled(Value)`
    margin-right: 10px;
    color: ${longColour};
`;

const ShortValue = styled(Value)`
    color: ${shortColour};
`;

export const YourContributors = ({longs, shorts}) => {
    const longCount = longs.length;
    const shortCount = shorts.length;
    return <Container className="t-open-ideas">
        <Header>Your Contributors</Header>
        <Title>Open Ideas</Title>
        <Values className="t-value">
            <LongValue className="t-open-long-count" count={longCount}>{longCount}L</LongValue>
            <ShortValue className="t-open-short-count" count={shortCount}>{shortCount}S</ShortValue>
        </Values>
    </Container>;
}